import { useLanguage } from "../i18n/LanguageContext";
import { MaskedLines, Overline, Reveal } from "./motion";
import { CRAFT } from "../data/products";

export const CraftSection = () => {
  const { t, lang } = useLanguage();
  const { wood, joinery, upholstery } = CRAFT;
  return (
    <section data-testid="craft-section" className="bg-[#F3EFEA]">
      <div className="mx-auto max-w-[1400px] px-6 py-24 md:px-12 md:py-36 lg:px-20">
        <Reveal y={14}>
          <Overline className="mb-6">{t.detail.craftOverline}</Overline>
        </Reveal>
        <h2 data-testid="craft-title" className="font-serif text-4xl font-light leading-[1.02] tracking-tight text-[#1C1C1A] md:text-6xl">
          <MaskedLines lines={t.detail.craftTitle} />
        </h2>

        <div className="mt-20 grid gap-12 lg:grid-cols-12 lg:gap-16">
          <Reveal className="lg:col-span-7">
            <div className="group overflow-hidden">
              <img src={wood.image} alt={wood.title[lang]} className="aspect-[5/4] w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.04]" />
            </div>
          </Reveal>
          <div className="lg:col-span-5 lg:self-end">
            <Reveal delay={0.15}>
              <p data-testid="craft-wood-stat" className="font-serif text-7xl font-light leading-none tracking-tight text-[#1C1C1A] md:text-8xl">{wood.stat}</p>
              <h3 className="mt-4 font-mono text-[11px] uppercase tracking-[0.3em] text-[#1C1C1A]">{wood.title[lang]}</h3>
              <p data-testid="craft-wood-text" className="mt-6 max-w-md text-base font-light leading-relaxed text-[#66625A]">{wood.text[lang]}</p>
            </Reveal>
          </div>
        </div>

        <div className="mt-24 grid gap-12 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-5 lg:order-1">
            <Reveal delay={0.1}>
              <h3 className="font-mono text-[11px] uppercase tracking-[0.3em] text-[#1C1C1A]">{joinery.title[lang]}</h3>
              <p data-testid="craft-joinery-text" className="mt-6 max-w-md text-base font-light leading-relaxed text-[#66625A]">{joinery.text[lang]}</p>
            </Reveal>
          </div>
          <Reveal className="lg:col-span-6 lg:col-start-7 lg:order-2">
            <div className="group overflow-hidden">
              <img src={joinery.image} alt={joinery.title[lang]} className="aspect-[4/5] w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.04]" />
            </div>
          </Reveal>
        </div>
      </div>

      <div data-testid="upholstery-section" className="bg-[#1C1C1A] text-[#FAF8F5]">
        <div className="mx-auto grid max-w-[1400px] gap-12 px-6 py-24 md:px-12 md:py-36 lg:grid-cols-12 lg:gap-16 lg:px-20">
          <Reveal className="lg:col-span-5">
            <div className="group overflow-hidden">
              <img src={upholstery.image} alt={upholstery.title[lang]} className="aspect-[4/5] w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-[1.04]" />
            </div>
          </Reveal>
          <div className="lg:col-span-6 lg:col-start-7 lg:self-center">
            <Reveal y={14}>
              <Overline light className="mb-6">{upholstery.title[lang]}</Overline>
            </Reveal>
            <h2 data-testid="upholstery-title" className="font-serif text-4xl font-light leading-[1.02] tracking-tight md:text-6xl">
              <MaskedLines lines={[upholstery.title[lang], upholstery.sub[lang]]} />
            </h2>
            <Reveal delay={0.2}>
              <ul data-testid="upholstery-points" className="mt-12 divide-y divide-[#FAF8F5]/10">
                {upholstery.points[lang].map((p, i) => (
                  <li key={p} className="flex gap-8 py-5">
                    <span className="font-serif text-lg italic text-[#C5A059]">{String(i + 1).padStart(2, "0")}</span>
                    <span className="text-base font-light leading-relaxed text-[#FAF8F5]/80">{p}</span>
                  </li>
                ))}
              </ul>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
